import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

export interface PerksConfig {
  membershipId?: string;
  internalTitle?: string;
  titleSize?: string;
  description?: string;
  columns?: string;
  columnAlignment?: string;
  showSearch?: boolean;
  showProgramName?: boolean;
  showTierImage?: boolean;
  showTierName?: boolean;
  showTierDescription?: boolean;
  showQuickAdd?: boolean;
  showRecentPosts?: boolean;
  showVideoTitle?: boolean;
  showVideoDate?: boolean;
  searchQuery?: string;
  // Colors & Border
  cardBackgroundColor?: string;
  cardTextColor?: string;
  cardButtonColor?: string;
  cardButtonTextColor?: string;
  columnBorderColor?: string;
  columnBorderWidth?: string;
  borderRadius?: string;
}
export const PerksConfigContext = createContext<PerksConfig>({});

export const usePerksConfig = () => useContext(PerksConfigContext);
